import {FeOrder} from "../../../orders/redux/types";
import React, {FC} from "react";
import {DialogContent, Typography} from "@material-ui/core";
import {OrderPreviewCard} from "../../../orders/sharedComponents/OrderPreviewCard";

interface CalendarDayDialogOrdersProps {
    orders: FeOrder[];
}

export const CalendarDayDialogOrders: FC<CalendarDayDialogOrdersProps> = ({orders}) => {
    return (
        <DialogContent>
            <Typography
                variant="h6"
                color="secondary"
                style={{marginBottom: 4}}
            >
                Aufträge
            </Typography>
            {orders.map((order) =>
                <OrderPreviewCard order={order}/>
            )}
        </DialogContent>
    )
}
